import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { CourtBlockType }   from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    colors    : [],
    statuses  : [],
    sort      : {
        orderBy  : "position",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "COURT_BLOCK_TYPE_LOADING" });
    },

    /**
     * Fetches the Court Block Type List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await CourtBlockType.getAll(params);
        data.sort = params;
        dispatch({ type : "COURT_BLOCK_TYPE_LIST", data });
    },

    /**
     * Fetches a single Court Block Type
     * @param {Function} dispatch
     * @param {Number}   courtBlockTypeID
     * @returns {Promise}
     */
    async fetchElem(dispatch, courtBlockTypeID) {
        const data = await CourtBlockType.getOne({ courtBlockTypeID });
        dispatch({ type : "COURT_BLOCK_TYPE_ELEM", data });
    },

    /**
     * Fetches the Court Block Type Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await CourtBlockType.getEditData();
        dispatch({ type : "COURT_BLOCK_TYPE_EDIT", data });
    },

    /**
     * Edits/Creates a Court Block Type
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return CourtBlockType.edit(data);
    },

    /**
     * Deletes a Court Block Type
     * @param {Function} dispatch
     * @param {Number}   courtBlockTypeID
     * @returns {Promise}
     */
    deleteElem(dispatch, courtBlockTypeID) {
        return CourtBlockType.delete({ courtBlockTypeID });
    },
};



/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "COURT_BLOCK_TYPE_LIST", "COURT_BLOCK_TYPE_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "COURT_BLOCK_TYPE_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "COURT_BLOCK_TYPE_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : action.data.list,
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case "COURT_BLOCK_TYPE_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : action.data.elem,
            colors    : action.data.colors,
            statuses  : action.data.statuses,
        };

    case "COURT_BLOCK_TYPE_EDIT":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            colors    : action.data.colors,
            statuses  : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
